import React, { ReactNode } from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

const Track = styled.div`
  position: relative;
  width: 100%;
  height: 6px;
  border-radius: 2px;
  background-color: var(--lighter-gray);

  &.thin {
    height: 3px;
  }

  .fill {
    height: 100%;
    border-radius: 2px;

    &.positive {
      background-color: var(--positive-green);
    }
    &.negative {
      background-color: var(--inactive-orange);
    }
  }
`;

const limitPercentage = (n: number): number => Math.max(0, Math.min(100, n));

type Props = {
  score: number;
  positive: boolean;
  thin?: boolean;
  children?: ReactNode;
};

const ScoreBar = ({ score, positive, thin = false, children }: Props) => (
  <Track className={classNames('track', { thin })}>
    <div
      className={classNames('fill', { positive, negative: !positive })}
      style={{ width: `${limitPercentage(score)}%` }}
    />
    {children}
  </Track>
);

export default ScoreBar;
